import React from "react";
import style from "../../style.module.scss";
import zero from "../assets/zero.svg";
import graph from "../assets/graph.svg";
import cuvette from "../assets/cuvette.svg";
import power from "../assets/power.svg";
import specLight from "../assets/spec-light.svg";

export const Content = () => {
  return (
    <div className={style.content}>
      <p>
        To determine the amount of substance S in solution, the absorbance of S
        will be measured with a spectrophotometer. Following the measurement,
        the concentration of S will be determined in the Results section using a
        standard curve.
      </p>
      <div className={style.itemlist}>
        <div className={style.item}>
          <img src={specLight} alt="" />
          <span>
            1. Turn on the spectrophotometer and let the lamp warm up for 15
            minutes.
          </span>
        </div>
        <div className={style.item}>
          <img src={graph} alt="" />
          <span>
            2. Set the ideal wavelength for your substance of interest to
            measure the absorbance of the sample.
          </span>
        </div>
        <div className={style.item}>
          <img src={zero} alt="" />
          <span>
            3. Place the blank cuvette in the spectrophotometer chamber and
            close the lid. The blank cuvette contains the solution used to
            prepare the solution of substance S but without S. Press the zero
            button to set the absorbance of the blank control to zero. This
            calibration serves as a reference point when measuring the sample.
          </span>
        </div>
        <div className={style.item}>
          <img src={cuvette} alt="" />
          <span>
            4. Place the sample cuvette in the chamber and close the lid. Record
            the absorbance value of substance S. Repeat the measurement to
            produce a duplicate data point.
          </span>
        </div>
        <div className={style.item}>
          <img src={power} alt="" />
          <span>5. Remove the sample cuvette and turn off the instrument.</span>
        </div>
      </div>
      <p>
        You are now ready to use the spectrophotometer in the Protocol to
        measure the absorbance of a sample solution containing substance S.
      </p>
    </div>
  );
};
